<!-- 招聘-搜索 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img">
				<p class="header-title">搜索</p>
			</div>
			<div class="search-box">
				<div class="search-bar">
					<img src="../assets/search-icon.png" class="search-icon">
					<input type="search" value="" placeholder="请输入关键字进行搜索" class="search-input" disabled />
				</div>
			</div>
			<ul class="sub-tab-list">
				<li>默认排序</li>
				<li class="active">
					时间
					<img src="../assets/icon-6.png" class="tab-icon">
				</li>
			</ul>
		</div>


		<ul class="list">
			<li   @click="$router.push('/recruit-details')">
				<div class="item-top">
					<div class="top-between">
						<span class="font-1">AUTOSAR 工程师</span>
						<span class="font-2">30-50K·15薪</span>
					</div>
					<ul class="tag-list">
						<li>交互设计</li>
						<li>3DMAX</li>
						<li>自动驾驶</li>
					</ul>
					<p class="msg">上海埃恪深科技有限公司 · 上市 · 100人</p>
				</div>
				<div class="item-bottom">
					<div class="item-bottom-left">
						<img src="../assets/avatar.png" class="avarar">
						<span class="user-name">人力资源·郝先生</span>
					</div>
					<div class="item-bottom-right">
						<img src="../assets/icon-58.png" class="location-icon">
						北京市·海淀区
					</div>
				</div>
			</li>
			<!-- 暂无数据展示 -->
			<div class="normal-box-small">
				<img src="../assets/normal.png">
				暂无数据
			</div>
		</ul>


		<div class="float-box">
			<button type="button" @click="$router.push('/recruit-contact')">没找到？点我反馈</button>
		</div>


	</div>
</template>

<script>
	export default {
		components: {},
		data() {
			return {
				showReport: false,
				showOpenVip: false,
				status: 0
				// 举报参数
				// reportParams: {
				// 	type: 5, // 举报类型（1视频2视频评论3会员,4资料,5图文）
				// 	report_id: 0, // 举报内容的id
				// },
				// params: {
				// 	title: '', // 标题
				// 	sort_type: 1, // 1默认2时间升序3时间降序
				// 	page: 1, // 页数
				// 	page_num: 20, // 每页数
				// },
				// list: [],
				// loading: false,
				// finished: false,

				// isLogin: false,
				// isVip: false,
			};
		},
		mounted() {},
		methods: {},
	}
</script>

<style scoped>
	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 118px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.search-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-bar {
		flex: 1;
		height: 36px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 14px;
		margin-right: 8px;
	}

	.search-input {
		flex: 1;
		font-size: 14px;
	}

	.search-input::placeholder {
		color: #7F7F7F;
	}

	.tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 16px;
		color: #555555;
		position: relative;
	}

	.tab-list>li.active {
		font-size: 18px;
		font-weight: 500;
		color: #222222;
	}

	.tab-list>li.active::after {
		content: "";
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		width: 18px;
		height: 4px;
	}


	.sub-tab-list {
		width: 100%;
		height: 38px;
		display: flex;
		align-items: center;
	}

	.sub-tab-list>li {
		flex: 1;
		display: flex;
		justify-content: center;
		align-items: center;
		height: 38px;
		line-height: 38px;
		font-size: 14px;
		color: #555555;
		position: relative;
	}

	.sub-tab-list>li.active {
		font-weight: 500;
		color: #222222;
	}

	.sub-tab-list>li.active::after {
		content: "";
		width: 18px;
		height: 4px;
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
	}

	.tab-icon {
		width: 6px;
		margin-left: 2px;
	}

	.wrap {
		width: 100%;
		height: calc(100vh - 118px);
		display: flex;
		flex-direction: row;
		margin: 118px 0 0;
		box-sizing: border-box;
		background-color: #F4F4F4;
		overflow-y: auto;
	}

	.wrap-tab-list-none {
		height: calc(100vh - 90px);
		margin: 90px 0 0;
	}


	.sub-list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
		/*height: 100%;*/
		overflow: auto;
	}

	.sub-list>li {
		width: 100%;
		display: flex;
		align-items: center;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 10px;
		box-sizing: border-box;
		position: relative;
	}


	.sub-list>li:last-child {
		margin-bottom: 0;
	}

	.float-box {
		position: fixed;
		left: 50%;
		transform: translate(-50%, 0);
		bottom: 40px;
		z-index: 499;
	}

	.float-box>button {
		min-width: 175px;
		height: 44px;
		line-height: 44px;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: #2A63F3;
		border-radius: 100px;
		color: #FFFFFF;
		font-size: 18px;
		font-weight: 500;
	}


	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 12px 15px;
		box-sizing: border-box;
	}

	.list>li {
		width: 100%;
		background-color: #FFFFFF;
		box-shadow: 0 0 12px rgba(0, 0, 0, 0.08);
		border-radius: 12px;
		margin-bottom: 12px;
		padding: 0 10px;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.item-top {
		width: 100%;
		padding: 10px 0;
		border-bottom: 1px solid #F2F2F2;
		box-sizing: border-box;
		display: flex;
		flex-direction: column;
	}

	.top-between {
		width: 100%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 7px;
	}

	.font-1 {
		color: #222222;
		font-size: 16px;
		font-weight: bold;
	}

	.font-2 {
		color: #FF3535;
		font-size: 14px;
		font-weight: bold;
	}

	.tag-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
	}

	.tag-list>li {
		color: #2A63F3;
		font-size: 10px;
		height: 16px;
		line-height: 16px;
		padding: 0 4px;
		margin-bottom: 6px;
		background-color: #F3F3F3;
		margin-right: 6px;
		border-radius: 3px;
	}

	.msg {
		width: 100%;
		color: #666666;
		font-size: 12px;
		margin-top: 2px;
	}

	.item-bottom {
		width: 100%;
		padding: 10px 0;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.item-bottom-left {
		display: flex;
		align-items: center;
	}

	.avarar {
		width: 20px;
		height: 20px;
		border-radius: 50%;
		margin-right: 6px;
	}

	.user-name {
		font-size: 10px;
		color: #888888;
	}

	.item-bottom-right {
		display: flex;
		align-items: center;
		color: #999999;
		font-size: 10px;
	}

	.location-icon {
		width: 10px;
		margin-right: 6px;
	}

	.normal-box-small {
		width: 100%;
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: 14px;
		color: #999992;
		padding: 120px 0;
	}

	.normal-box-small>img {
		width: 150px;
		margin-bottom: 9px;
	}
</style>
